import MicroModal from 'micromodal'
import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.element[this.identifier] = this
    if (!this.element.id) {
      this.element.id = 'modal_' + Math.random().toString(36).substr(2, 9)
    }

    MicroModal.show(this.element.id, {
      onClose: (modal) => this.close()
    })
  }

  close() {
    this.element.remove()
    if(document.getElementById("modal")){
      document.getElementById("modal").removeAttribute('src')
    }
    else{
      this.element.removeAttribute('src')
    }
  }

  refresh() {
    setTimeout(() => {  location.href = '' }, 1000)
  }
}
